import { useTranslation } from "@/langs/useTranslation";

export default function MapPlaceholder(props) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        height: props.height || 300,
        fontSize: 16,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      {t({ defaultMessage: "设备分布地图建设中" })}
    </div>
  );
}
